import React from 'react'
import { Trans, t } from '@lingui/macro'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import Tooltip from '../../../components/common/tooltip/Tooltip'
import IconQuestion from '../../../components/common/icon/IconQuestion'
import IconPencil from '../../../components/common/icon/IconPencil'
import IconButton from '../../../components/common/form/button/IconButton'
import { linkBuilder } from '../../../../../shared/linkBuilder'
import { navigateTo } from '../../../app/util/appHistory'
import { notification as pageNotification } from '../../../components/common/notifications/Notifications'
import './EmailBlacklistItem.less'
import IconCopy from 'front-end/src/components/common/icon/IconCopy'
import { Link } from 'front-end/src/components'

export const BlacklistedEmailItem = (props) => {
  const { email, user, notification } = props

  const { message } = notification
  const { bounce, complaint } = message || {}

  let actionMessage = t`Contact us`
  let canEdit = false
  let responseDetails
  let issueDetails

  const CopyResponseDetails = () => {
    return (
      <div className="Action">
        <span className="Action__icon">
          <IconCopy />
        </span>{' '}
        <span className="Action__text">
          <Trans>Copy response details to clipboard</Trans>
        </span>
      </div>
    )
  }

  if (bounce) {
    const bouncedEmailIndex = bounce.bouncedRecipients.findIndex(
      (item) => item.emailAddress === email
    )
    let bounceStatusCode

    if (bouncedEmailIndex !== -1) {
      bounceStatusCode = bounce.bouncedRecipients[bouncedEmailIndex].status
    }

    if (bounceStatusCode === '5.1.1' || bounceStatusCode === '5.1.10') {
      canEdit = true
      actionMessage = t`Amend email address`
    }

    responseDetails = JSON.stringify(
      bounce.bouncedRecipients[bouncedEmailIndex]
    )
    issueDetails = (
      <>
        <div className="Tooltip">
          <div className="Tooltip__text">
            <Trans>SMTP response status code</Trans>:{' '}
            <span className="Tooltip__text__code">{bounceStatusCode}</span>
          </div>
          {canEdit && (
            <div className="Tooltip__text">
              <Trans>
                The email address does not exist. You can fix this issue by
                amending users email address.
              </Trans>
            </div>
          )}
          {!canEdit && (
            <div className="Tooltip__text">
              <Trans>There is an issue with the email address.</Trans>
            </div>
          )}
          {canEdit && (
            <div className="Action">
              <span className="Action__icon">
                <IconPencil />
              </span>
              <span className="Action__text">
                <Trans>Amend email address</Trans>
              </span>
            </div>
          )}
          <CopyResponseDetails />
        </div>
      </>
    )
  } else if (complaint) {
    responseDetails = JSON.stringify(complaint)
    issueDetails = (
      <>
        <div className="Tooltip">
          <div className="Tooltip__text">
            <Trans>We have received</Trans>:{' '}
            <span className="Tooltip__text__code">
              <Trans>Complaint</Trans>
            </span>
          </div>
          <div className="Tooltip__text">
            <Trans>
              A complaint indicates the recipient does not want the email that
              you sent them.
            </Trans>
          </div>
          <CopyResponseDetails />
        </div>
      </>
    )
  } else {
    issueDetails = (
      <>
        <div className="Tooltip">
          <div className="Tooltip__text">
            <Trans>
              Contact{' '}
              <Link href="mailto:support@looop.co">support@looop.co</Link>
            </Trans>
          </div>
          <CopyResponseDetails />
        </div>
      </>
    )
  }

  return (
    <div className="ListItem">
      <div className="ListItem-email">{email}</div>
      <div className="ListItem-required-action">
        <Tooltip text={issueDetails}>
          {actionMessage}
          <IconQuestion />
        </Tooltip>
      </div>
      <div className="ListItem-actions">
        {canEdit && (
          <IconButton
            icon={<IconPencil />}
            hint={t`Amend email`}
            onClick={() => {
              navigateTo(linkBuilder.userDetail(user.id))
            }}
          />
        )}

        <CopyToClipboard
          text={responseDetails}
          onCopy={() =>
            pageNotification.info(
              t`Response details were successfully copied to clipboard`
            )
          }
        >
          <IconButton
            icon={<IconCopy />}
            hint={t`Copy response details to clipboard`}
          />
        </CopyToClipboard>
      </div>
    </div>
  )
}
